import { render, staticRenderFns } from "./RegionSetupList.vue?vue&type=template&id=7f8adc06&scoped=true"
import script from "./RegionSetupList.vue?vue&type=script&lang=js"
export * from "./RegionSetupList.vue?vue&type=script&lang=js"
import style0 from "./RegionSetupList.vue?vue&type=style&index=0&id=7f8adc06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8adc06",
  null
  
)

export default component.exports